var render = function render(){var _vm=this,_c=_vm._self._c;return _c('radio-selection',{attrs:{"options":_vm.urgencyOptions,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }